import { createFileRoute, Link } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";
import { AlOrderScreen } from "@/routes/_authenticated/_care/residents/$residentId/-components/documents/al-order-screen";

export const Route = createFileRoute("/_authenticated/_crm/crm/leads/$leadId_/al-orders/$orderId")({
  component: AlOrderView,
});

function AlOrderView() {
  const { leadId, orderId } = Route.useParams();
  // The enquiry stands where the resident would: the same page prints for
  // both, and conversion moves the document without changing it.
  const { data: resident } = useSuspenseQuery(
    orpc.crm.leads.get.queryOptions({ input: { leadId } }),
  );

  return (
    <AlOrderScreen
      orderId={orderId}
      resident={resident}
      back={
        <Link params={{ leadId }} search={{ tab: "physician" }} to="/crm/leads/$leadId">
          Back to the enquiry
        </Link>
      }
      printLabel="Print order"
      missingDescription="It may have been removed, or it belongs to somebody else. The enquiry lists every order on file."
    />
  );
}
